function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m26.073 25.036-24.113.927L2 27l-.04-1.037L1 26l.96-.037-.923-24L0 2l1.037-.037L1 1l.037.963 25.925-.926L27 0l-.038 1.037L28 1l-1.038.037-.889 24L27 25l-.927.036L26 27Zm-24.113.927 24.113-.927.889-24-25.925.927ZM12.5 20v-6H11v-1h1.5V9.5A1.5 1.5 0 0 1 14 8h2.5v1H14a.5.5 0 0 0-.5.5V13h2l-.25 1H13.5v6Z",
    style: {
      fill: "none",
      stroke: "#1e2022",
      strokeLinecap: "square",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    transform: "translate(2 2)"
  }));
};
export default SvgFacebook;